import { mapperModuleNavigationLink, mapperModuleUsp } from '../../../core/data-layer/modules/mappers'
import {
  mapperBlockCallToAction,
  mapperBlockFaqGroup,
  mapperBlockMediaCardGroup
} from '../../../core/data-layer/blocks/mappers'
import { mapperPaymentsPaymentMethod } from '../payment-methods/mapper-payments-payment-method'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page payment method detail mapper
 * normalizes data to be used in pages
 *
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  const documentationLink = mapperModuleNavigationLink(data.documentationLink, options.getUrl)

  return {
    paymentMethod: mapperPaymentsPaymentMethod(data, options.getUrl),
    documentationLink: documentationLink
      ? { ...documentationLink, ...{ title: options.labels?.documentationLinkText } }
      : null,
    usps: data.uspsCollection?.items?.map((item) => mapperModuleUsp(item)).filter(Boolean) || [],
    howItWorks:
      data.galleriesCollection?.items.filter(Boolean).map((item) => mapperBlockMediaCardGroup(item, options)) || [],
    faq: mapperBlockFaqGroup(data.faq),
    callToAction: mapperBlockCallToAction(data.callToAction, options.getUrl),
    pricingLink: mapperModuleNavigationLink(options.labels?.pricingLink, options.getUrl),
    related: data.relatedCollection.items // Mapping happens after
  }
}
